import { render, staticRenderFns } from "./AgencyNotificationSettings.vue?vue&type=template&id=3cf74a4b"
import script from "./AgencyNotificationSettings.vue?vue&type=script&lang=js"
export * from "./AgencyNotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports